import { v4 as uuidv4 } from 'uuid';

export const toSlug = (text: string) =>
    text
        .normalize('NFD') // Elimina acentos
        .replaceAll(/[\u0300-\u036f]/g, '') // Elimina caracteres diacríticos
        .toLowerCase()
        .trim()
        .replaceAll(/[^a-z0-9 -]/g, '') // Elimina caracteres no deseados
        .replaceAll(/\s+/g, '-') // Reemplaza espacios por guiones
        .replaceAll(/-+/g, '-');

export const capitalize = (s: string) => s[0]?.toUpperCase() + s.slice(1).toLowerCase();

export const capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

export const firstLowerCase = (str: string) => str?.charAt(0).toLowerCase() + str?.slice(1);

export const getUUID = (): string => uuidv4();

export const toStringValue = (value: string | (string | number)[] | null | undefined): string =>
    Array.isArray(value) ? String(value[0] ?? '') : (value ?? '').toString();

export const normalizeString = (value?: string): string => (value ?? '').trim().toLowerCase();

export const isNotEmpty = (value: string): boolean => value.trim().length > 0;

export const toKebabCase = (value: string): string => value.toLowerCase().replaceAll('_', '-');
